import { render, staticRenderFns } from "./StudentSchedulePage.vue?vue&type=template&id=21a72414&scoped=true"
import script from "./StudentSchedulePage.vue?vue&type=script&lang=js"
export * from "./StudentSchedulePage.vue?vue&type=script&lang=js"
import style0 from "./StudentSchedulePage.vue?vue&type=style&index=0&id=21a72414&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21a72414",
  null
  
)

export default component.exports